<div class="gameHeader">
  <button class="back leftbtn">
    <a href="/dge/lobby" routerLink="/dge/lobby">
      <svg class="svgicon">
        <use xlink:href="assets/images/sprite-sheet.svg#icon-leftarrow"></use>
      </svg>
    </a>
  </button>
  <div class="pageIndicator">
    <div class="title">{{'dge.my_tickets' | translate}}</div>
    <div class="userinfo">
      <div class="userName">{{userInfo?.playername}}</div>
      <!-- <div class="balanceWrap" innerHTML="{{userInfo?.balance | custCurrency}}"></div> -->
      <div class="balanceWrap" *ngIf="clientCode != 'guinee'" innerHTML="{{userInfo?.balance | custCurrency}}"></div>
      <div class="balanceWrap" *ngIf="clientCode == 'guinee'"><span class="no-wrap">{{userInfo?.currDisplay | currencySymbol}} {{numberWithSpaces(userInfo?.balance)}}</span></div>
    </div>
  </div>
</div>
<div class="tktFilterWrap">
  <div class="sectionWrapper">
    <div class="blkWrap">
      <div class="selectWrap">
        <label for="slt-game">{{'dge.game' | translate}}</label>
        <select id="slt-game" [(ngModel)]="gameSelect" (change)="getTicketList('view')">
          <option value="{{item.gameCode}}" *ngFor="let item of gameList; let i = index">
            {{'common.' + item.gameCode | translate}}</option>
        </select>
      </div>
    </div>
    <div class="blkWrap">
      <div class="selectWrap">
        <label for="slt-sort">{{'dge.sort_by' | translate}}</label>
        <select id="slt-sort" [(ngModel)]="sortBy" (change)="sortMeBy('view')">
          <option value="{{ item.code }}" *ngFor="let item of sortByMap; let i = index">{{ item.name }}</option>
        </select>
      </div>
    </div>
  </div>
</div>
<div class="tktListWrap">
  <div class="sectionWrapper">
    <div class="msg-section" *ngIf="!ticketTable">
      <h2>{{'common.no_ticket_purchase' | translate}}</h2>
      <div class="buttonWrap" (click)="purchaseTicketUrl()"><button>{{'common.buy_tickets' | translate}}</button></div>
    </div>
    <div class="tktList" *ngIf="ticketTable">
      <div class="tktHeader">
        <div class="head head1">
          <div class="title">{{'sle.txn_time' | translate}}</div>
        </div>
        <div class="head head2">
          <div class="title">{{'sle.ticket_no' | translate}}</div>
        </div>
        <div class="head head3">
          <div class="title">{{'sle.game_name' | translate}}</div>
        </div>
        <div class="head head4">
          <div class="title">{{'sle.draw_no' | translate}}</div>
        </div>
        <div class="head head5">
          <div class="title">{{'sle.draw_time' | translate}}</div>
        </div>
        <div class="head head6">
          <div class="title">{{'sle.bet_win_status' | translate}}</div>
        </div>
      </div>
      <div class="tkt" *ngFor="let tkt of myTickets | paginate:{itemsPerPage: 10, currentPage:p};"
        (click)="loadTicket(tkt?.ticketNumber, tkt.drawDetails.drawId)">
        <!-- <div class="tkt" *ngFor="let tkt of myTickets" (click)="loadTicket(tkt?.ticketNumber, tkt.drawDetails.drawId)"> -->
        <div class="box box1">
          <div class="elementWrap ele-txn">
            <div class="label">{{'sle.txn_time' | translate}}</div>
            <div class="element">
              <div class="date">
                <span class="month">{{changeDateFormat(tkt.transactionDate) | date: 'MMM'}}</span>
                <span class="date">{{changeDateFormat(tkt.transactionDate) | date: 'dd'}}</span>
              </div>
              <div class="time">
                <span class="hour">{{changeDateFormat(tkt.transactionDate) | date: 'HH'}}</span>
                <span class="minute">{{changeDateFormat(tkt.transactionDate) | date: 'mm'}}</span>
                <span class="second">{{changeDateFormat(tkt.transactionDate) | date: 'ss'}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="box box2">
          <div class="elementWrap ele-tkt">
            <div class="label">{{'sle.ticket_no' | translate}}.</div>
            <div class="element">
              <div class="value">{{ tkt.ticketNumber }}</div>
            </div>
          </div>
          <div class="elementWrap ele-game">
            <div class="label">{{'sle.game' | translate}}</div>
            <div class="element">
              <div class="value">{{'common.' + tkt.gameCode | translate}}</div>
            </div>
          </div>
          <div class="elementWrap ele-drawnum">
            <div class="label">{{'sle.draw_no' | translate}}</div>
            <div class="element">
              <div class="value">{{ tkt.drawDetails.drawId }}</div>
            </div>
          </div>
          <div class="elementWrap ele-draw">
            <div class="label">{{'sle.draw_time' | translate}}</div>
            <div class="element">
              <div class="valueGroup upcoming">
                <div class="date">
                  <span class="month">{{changeDateFormat(tkt.drawDetails.drawDateTime) | date: 'MMM'}}</span>
                  <span class="date">{{ changeDateFormat(tkt.drawDetails.drawDateTime) | date: 'dd'}}</span>
                </div>
                <div class="time">
                  <span class="hour">{{changeDateFormat(tkt.drawDetails.drawDateTime) | date: 'HH'}}</span>
                  <span class="minute">{{changeDateFormat(tkt.drawDetails.drawDateTime) | date: 'mm'}}</span>
                  <span class="second">{{changeDateFormat(tkt.drawDetails.drawDateTime) | date: 'ss'}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box box3">
          <div class="elementWrap ele-bet" *ngIf="tkt.ticketDetails.winningAmount <= 0">
            <div class="label">{{'sle.bet' | translate}}</div>
            <div class="element">
              <div class="amountWrap betValue" *ngIf="clientCode != 'guinee'" innerHTML="{{tkt.ticketDetails.saleAmount | custCurrency}}"></div>
              <div class="amountWrap betValue" *ngIf="clientCode == 'guinee'"><span class="no-wrap">{{userInfo?.currDisplay | currencySymbol}} {{numberWithSpaces(tkt.ticketDetails.saleAmount)}}</span></div>
            </div>
          </div>
          <div class="elementWrap ele-win" *ngIf="tkt.ticketDetails.winningAmount > 0 && tkt.ticketDetails.winstatus != 'RESULT_AWAITED'">
            <div class="label">{{'common.win' | translate}}</div>
            <div class="element">
              <div class="amountWrap winning" *ngIf="clientCode != 'guinee'" innerHTML="{{tkt.ticketDetails.winningAmount | custCurrency}}"></div>
              <div class="amountWrap winning" *ngIf="clientCode == 'guinee'"><span class="no-wrap">{{userInfo?.currDisplay | currencySymbol}} {{numberWithSpaces(tkt.ticketDetails.winningAmount)}}</span></div>
            </div>
          </div>
          <div class="elementWrap ele-bet"   *ngIf="tkt.ticketDetails.winningAmount > 0 && tkt.ticketDetails.winstatus == 'RESULT_AWAITED'">
            <div class="label">{{'sle.bet' | translate}}</div>
            <div class="element">
              <div class="amountWrap betValue"  *ngIf="clientCode != 'guinee'" innerHTML="{{tkt.ticketDetails.saleAmount | custCurrency}}"></div>
              <div class="amountWrap betValue"  *ngIf="clientCode == 'guinee'"><span class="no-wrap">{{userInfo?.currDisplay | currencySymbol}} {{numberWithSpaces(tkt.ticketDetails.saleAmount)}}</span></div>
            </div>
          </div>
          <div class="elementWrap ele-status">
            <div class="label">{{'sle.status' | translate}}</div>
            <div class="element" [ngSwitch]="tkt.ticketDetails.winstatus">
              <div class="st-icon" *ngSwitchCase="'SOLD'">
                <svg class="svgicon wait">
                  <use xlink:href="assets/images/sprite-sheet.svg#icon-waittime"></use>
                </svg>
              </div>
              <div class="st-icon" *ngSwitchCase="'WIN'">
                <svg class="svgicon moneysack">
                  <use xlink:href="assets/images/sprite-sheet.svg#icon-moneysack"></use>
                </svg>
              </div>
              <div class="st-icon" *ngSwitchCase="'CLAIMED'">
                <svg class="svgicon moneysack">
                  <use xlink:href="assets/images/sprite-sheet.svg#icon-moneysack"></use>
                </svg>
              </div>
              <div class="st-icon" *ngSwitchCase="'NON-WIN'">
                <svg class="svgicon sad">
                  <use xlink:href="assets/images/sprite-sheet.svg#icon-sadface"></use>
                </svg>
              </div>
              <div class="st-icon" *ngSwitchCase="'CANCELLED'">
                <svg class="svgicon cancel">
                  <use xlink:href="assets/images/sprite-sheet.svg#icon-cancel"></use>
                </svg>
              </div>
              <div class="st-icon" *ngSwitchDefault>
                <svg class="svgicon loader">
                  <use xlink:href="assets/images/sprite-sheet.svg#icon-loader"></use>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right">
        <pagination-controls (pageChange)="pageChange($event)" autoHide="true" previousLabel="" nextLabel="">
        </pagination-controls>
      </div>
      <!-- <div class="center">
        <div class="pagination">
          <a href="#">&laquo;</a>
          <a href="#">1</a>
          <a href="#" class="active">2</a>
          <a href="#">3</a>
          <a href="#">4</a>
          <a href="#">5</a>
          <a href="#">6</a>
          <a href="#">&raquo;</a>
        </div>
      </div> -->
    </div>
  </div>
</div>